<div class="d-flex align-items-center">
  <fa-icon class="me-4"
           [icon]="['fab', 'apple']"></fa-icon>
  <div class="flex-grow-1 lh-1 text-truncate">
    <h6 class="mb-1">{{ asset()?.name }}</h6>
    <p class="mb-0 lh-1 text-truncate">
      <small class="text-truncate">{{ asset()?.bundleId }}</small>
    </p>
  </div>
  <label for="appVersionSelect"
         class="me-2"
         i18n>Version: {{ asset()?.version }}</label>
</div>